// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import breakpoint from 'styled-components-breakpoint';
import { injectIntl } from 'react-intl';
import type { InjectIntlProvidedProps } from 'react-intl';

import calendarSvg from '../assets/calendar.svg';

type Props = InjectIntlProvidedProps & {
  fromDate: string,
  toDate: string,
  children?: any,
  subscriptionIsActive: boolean,
  premiumPlan?: boolean,

  onPeriodClick: () => any,
};

const Wrapper = styled.div`
  padding: 10px 15px;
  min-width: 260px;
  min-height: 43px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  color: #3c4042;
  border: solid 1px #c1c2c3;
  border-radius: 4px;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.06);
  background: #edeff2;
  font-size: 0.9em;
  cursor: pointer;

  ${breakpoint('tablet')`
    margin-right: 20px;
  `};

  ${ifProp(
    'disabled',
    css`
      cursor: not-allowed;
    `,
  )};
`;

const Image = styled.img`
  margin-right: 10px;
  height: 14px;
`;

const DatePeriod = (props: Props) => {
  const fromYearText = props.intl.formatDate(props.fromDate, {
    year: 'numeric',
  });
  const toYearText = props.intl.formatDate(props.toDate, {
    year: 'numeric',
  });
  const fromDateText = props.intl.formatDate(props.fromDate, {
    day: 'numeric',
    month: 'short',
  });
  const toDateText = props.intl.formatDate(props.toDate, {
    day: 'numeric',
    month: 'short',
  });

  let disabled = !props.subscriptionIsActive;
  let dateForAct = false;
  if (typeof props.premiumPlan !== 'undefined') {
    !props.premiumPlan && (disabled = true);
    dateForAct = true;
  }

  return (
    <Wrapper
      onClick={
        props.subscriptionIsActive &&
        (() => {
          if (!dateForAct || (dateForAct && !disabled)) {
            props.onPeriodClick();
          }
        })
      }
      disabled={disabled}
    >
      {' '}
      <Image src={calendarSvg} alt="Set date period" />
      {`${fromDateText} ${fromYearText} - ${toDateText} ${toYearText}`}
    </Wrapper>
  );
};

export default injectIntl(DatePeriod);
